/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHttpTrace = createReactComponent("outline", "http-trace", "IconHttpTrace", [["path", { "d": "M3 8h4", "key": "svg-0" }], ["path", { "d": "M5 8v8", "key": "svg-1" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-2" }], ["path", { "d": "M17 16v-6a2 2 0 1 1 4 0v6", "key": "svg-3" }], ["path", { "d": "M17 13h4", "key": "svg-4" }]]);

export { IconHttpTrace as default };
//# sourceMappingURL=IconHttpTrace.mjs.map
